import { render, staticRenderFns } from "./policy-compliance-status-description.vue?vue&type=template&id=6c01b8e8"
import script from "./policy-compliance-status-description.vue?vue&type=script&lang=js"
export * from "./policy-compliance-status-description.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports